import { View } from "@Engage.Data/modules/view/View";
/**
 * VisitInLastDaysQualifier
 * Returns the number of distinct days visited within the last N days.
 *
 * Server sends the qualifier value as:
 *   - a number:  7
 *   - a string:  "7"
 *   - an array:  [7] or ["7"]
 *
 * The returned count is compared server-side against the configured threshold.
 */
export class VisitInLastDaysQualifier {
    constructor() {
        this.key = "VisitsLastDays";
    }
    process(value) {
        try {
            const raw = Array.isArray(value) ? value[0] : value;
            const days = parseInt(String(raw !== null && raw !== void 0 ? raw : "0"), 10);
            // when server sends empty array or no value, return total visit count across all days
            if (isNaN(days) || days <= 0) {
                const total = View.getVisitedViewsByDays(Number.MAX_SAFE_INTEGER);
                return String(total);
            }
            const count = View.getVisitedViewsByDays(days);
            return String(count);
        }
        catch (e) {
            console.error('[VisitInLastDaysQualifier] error', e);
            return "0";
        }
    }
}
